(function () {
  function clampQuantity(input, delta) {
    var min = Number(input.min || 1);
    var max = Number(input.max || 99);
    var current = Number(input.value || min);
    input.value = Math.min(max, Math.max(min, current + delta));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function handleQuantity(event) {
    var minus = event.currentTarget.hasAttribute('data-fv-qty-minus');
    var control = event.currentTarget.closest('.fv-qty');
    var input = control && control.querySelector('.fv-qty__input');
    if (!input) return;
    clampQuantity(input, minus ? -1 : 1);
  }

  function handleSubmit(event) {
    var form = event.currentTarget;
    if (!window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('[data-fv-add]');
    var label = button.querySelector('span');
    var status = form.querySelector('[data-fv-order-status]');
    var original = label.textContent;
    button.disabled = true;
    label.textContent = 'Adding…';
    status.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString()
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add this item');
        return Promise.all([response.json(), fetch('/cart.js').then(function (r) { return r.json(); })]);
      })
      .then(function (results) {
        var cart = results[1];
        document.querySelectorAll('[data-cart-count], .cart-count, #cart-count, .cart-item-count').forEach(function (node) {
          node.textContent = cart.item_count;
        });
        label.textContent = 'Added ✓';
        status.textContent = 'Added to your cart.';
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        setTimeout(function () { label.textContent = original; }, 1600);
      })
      .catch(function (error) {
        label.textContent = original;
        status.textContent = error.message || 'Please try again.';
      })
      .finally(function () { button.disabled = false; });
  }

  function initialiseOrdering() {
    document.documentElement.classList.add('fv-modern-ready');
    document.querySelectorAll('[data-fv-qty-minus], [data-fv-qty-plus]').forEach(function (button) {
      button.addEventListener('click', handleQuantity);
    });
    document.querySelectorAll('[data-fv-quick-order]').forEach(function (form) {
      form.addEventListener('submit', handleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseOrdering);
  } else {
    initialiseOrdering();
  }
})();
